import "./index.css";
import { clsx } from "clsx";
import type { ElementType } from "react";
import type { IHeadingProps } from "./types";

export const Heading = <T extends ElementType = "h2">({
  level,
  as,
  tone,
  className,
  ...props
}: IHeadingProps<T>) => {
  const Component: ElementType = as ?? `h${level}`;

  return (
    <Component
      {...props}
      className={clsx(
        "nuco-heading",
        `nuco-heading--${level}`,
        tone && `nuco-heading--${tone}`,
        className,
      )}
    />
  );
};
